type ConsentSettings = {
  ad_personalization: "denied";
  ad_storage: "denied";
  ad_user_data: "denied";
  analytics_storage: "denied";
  functionality_storage: "denied";
  personalization_storage: "denied";
  security_storage: "granted";
  wait_for_update: number;
};

type GtagArguments =
  | ["consent", "default", ConsentSettings]
  | ["set", "ads_data_redaction" | "url_passthrough", boolean]
  | ["js", Date]
  | ["config", string]
  | ["event", "generate_lead"];

export type Gtag = (...args: GtagArguments) => void;

declare global {
  interface Window {
    dataLayer: IArguments[];
    gtag: Gtag;
  }
}

export function trackGenerateLead(gtag: Gtag | undefined = window.gtag): void {
  gtag?.("event", "generate_lead");
}
